import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

/**
 * Contextual internal cross-links. Unlike nav/footer, these sit inside page
 * content and pass link equity with descriptive anchor text — the on-site SEO
 * lever most worth automating on a multi-page app.
 */
export default function RelatedLinks({ links = [] }) {
  if (!links.length) return null;
  return (
    <section className="border-t border-border bg-muted/20 px-5 py-16 lg:px-8 lg:py-20">
      <div className="mx-auto max-w-7xl">
        <h2 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-accent">Keep Reading</h2>
        <p className="mt-3 max-w-xl font-heading text-2xl font-bold text-primary">Continue exploring</p>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {links.map((l, i) => (
            <Reveal key={l.to} delay={(i % 3) * 0.05}>
              <Link to={l.to} className="group flex h-full flex-col rounded-lg border border-border bg-background p-6 transition-colors hover:border-accent/40 hover:bg-muted/40">
                <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">{l.label}</span>
                <span className="mt-3 font-heading text-lg font-bold text-primary">{l.title}</span>
                <span className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">{l.desc}</span>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-accent">{l.cta || "Read more"} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}